export default {
  TEACHER_PROFILE: "profile.teacher",
  PARENT_PROFILE: "profile.parent",
  EMAIL_FORWARDING: "profile.email_forwarding",
  LOGIN_QRCODE: "profile.login_qrcode",
  READ_ORG_ACCOUNT: "org_account.read",
  WRITE_ORG_ACCOUNT: "org_account.write",
  STUDENT_PROFILE: "profile.student",
  FULL_MEMBER_PROFILE: "profile.full_member",
  FAMILY_PROFILE: "profile.family",
};
